import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, ThemeProvider, createMuiTheme } from '@material-ui/core';
import './index.css';
import { AnswerProvider, initState } from './context';
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { BrowserRouter as Router } from 'react-router-dom';

gsap.registerPlugin(MotionPathPlugin, CSSPlugin);

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 321,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    text: {
      primary: 'rgb(95, 99, 104)',
    },
    primary: {
      main: '#1a73e8',
    },
    action: {
      disabledBackground: '#f8f9fa',
      disabled: '#9aa0a6',
    },
  },
  typography: {
    fontFamily: '"Google Sans", Roboto, sans-serif',
    button: {
      textTransform: 'none',
      fontSize: '16px',
      lineHeight: '24px',
      padding: '12px 24px',
      fontWeight: 500,
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          height: '100vh',
        },
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: '0.85rem',
      },
    },
    MuiButton: {
      root: {
        padding: '12px 24px',
        '&:hover': {
          boxShadow: 'rgb(26 115 232) 0px 0px 0px 2px',
        },
        '&:focus': {
          border: '1px solid #ffffff',
          boxShadow: 'rgb(26 115 232) 0px 0px 0px 2px !important',
        },
      },
      label: {
        fontFamily: '"Google Sans", Roboto, sans-serif',
        fontSize: 16,
        lineHeight: '24px',
        fontWeight: 500,
        borderRadius: 4,
      },
      contained: {
        boxShadow: 'none',
      },
      containedPrimary: {
        boxShadow: 'none',
      },
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AnswerProvider data={initState}>
          <App />
        </AnswerProvider>
      </ThemeProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
